import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import BlogMain from './BlogMain';
import Footer from '../../components/Footer';

const Blog = () => {
  return (
    <>
      <HeaderSeven />

      <BlogMain />

      <Footer />
    </>
  );
};

export default Blog;
